<template>
  <div class="journey" ref="journey" v-if="loaded">
    <div class="journey-header">
      <div class="step-indicators">
        <a href="" class="overview-step" :class="{active: !canScrollLeft}" @click.prevent="revealOverview"></a>
        <JourneyProgress
        :steps="steps"
        :visible="visibleSteps"
        :interactive="true"
        @select="scrollTo($event)"
        ></JourneyProgress>
      </div>
      <div class="scroll-buttons">
        <a href=""
         @click.prevent="scroll('left')"
         @keyup.enter="scroll('left')"
         class="button explore"
         :class="{unavailable: !canScrollLeft}"> <LeftArrow :opacity="0.7"></LeftArrow> </a>
        <a href=""
        @click.prevent="scroll('right')"
        @keyup.enter="scroll('right')"
        class="button explore"
         :class="{unavailable: !canScrollRight}"> <RightArrow :opacity="0.7"></RightArrow> </a>
      </div>
      <span class="nav-icons">
        <a href=""
        @click.prevent="visitJourneys"
        @keyup.enter="visitJourneys"
        class="button all-journeys">
          <span class="new" v-if="newJourneysCount > 0"></span>
          <EmptyGrid class="grid-icon"></EmptyGrid>
          <span class="button-text">
            {{ $t('message.all-learner-journeys') }}
          </span>
        </a>
        <span class="spacer"></span>
        <a href=""
        @click.prevent="close"
        @keyup.enter="close"
        class="button exit">
          <X></X>
        </a>
        <a href=""
        @click.prevent="openProfileMenu"
        @keyup.enter="visitProfile"
        class="button avatar">
          <tooltip :text="$t('message.profile')">
            <img
            id="profile-menu-trigger"
            :src="currentUser.image"/>
          </tooltip>
        </a>
      </span>
    </div>
    <div class="journey-content-wrapper">
      <div class="journey-scroller" ref="scrollContainer">
        <div class="journey-content" ref="journeyContent" id="journey-content" :style="{width: contentWidth + 'px'}">
          <JourneyOverview
            ref="overview"
            :title="title"
            :media="media"
            :duration="duration"
            :description="description"
            :started="journey.started"
            :journeyId="id"
            :assigned="assigned"
            @updateEnrollment="(started)=>{updateEnrollment(started)}"
          >
          </JourneyOverview>
          <span
          v-for="step, index in steps"
          :ref="`step${index}`"
          class="step-container">
            <StepOutline
            :media="step.media"
            :task="step.task"
            :label="step.label"
            :started="journey.started"
            @update="() => loadJourney(false)"
            @promptStartJourney="promptStartJourney"
            ></StepOutline>
          </span>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="scroll-arrow-help" v-if="showScrollHelp" @click="dismissScrollHelp">
        <p>{{ $t('message.resource-scroll-help') }}</p>
      </div>
    </transition>
  </div>
</template>

<style lang="less" scoped>
  @overview-width: 490px;

  @import "./shared.less";
  .journey {
    width: 100%;
    left: 0;
    top: 0;
    color: white;
    padding-top: 90px;
    min-height: 100vh;

    .scroll-arrow-help {
      display: block;
      position: fixed;
      padding: 20px;
      background: #007fff;
      z-index: 2000;
      border-radius: 4px;
      box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.8);
      cursor: pointer;

      p {
        color: white;
      }

      &:before {
        display: block;
        content: "";
        border: 10px solid;
        border-color: #007fff transparent;
        border-top-color: #007fff;
        position: absolute;
        right: 30px;
      }

      @media(min-width: 800px) {
        top: 80px;
        right: 368px;

        &:before {
          border-top: none;
          top: -10px;
        }
      }

      @media(max-width: 799px) {
        bottom: 104px;
        right: 26px;

        &:before {
          border-bottom: none;
          bottom: -10px;
        }
      }
    }

    .journey-content {
      display: flex;
      overflow: hidden;
      background: #222;
      margin-top: -1px;
    }

    .journey-overview {
      flex-basis: @overview-width;
      flex-shrink: 0;
      background: #333;
      min-height: calc(100vh - 110px);
      margin: 10px;
      border-radius: 8px;
    }

    .step-container {
      margin: 40px 40px 180px 40px;
      width: calc(100vw - 80px);
      flex-shrink: 0;

      @media(min-width: 640px) {
        width: 325px;
      }
      @media(max-width: 640px) {
        margin: 12px 10px 180px 12px;
        width: calc(100vw - 22px);
      }
    }

    a.button {
      &.explore {
        margin-left: 5px;
        text-align: center;
        background: #e9e9e9;
        -webkit-appearance: none;

        .action-icon{
          position: relative;
          top: -2px;
        }

        &:hover{
          background: #FFF;
        }

        &.unavailable {
          background: #666;
        }

        &:first-of-type {
          margin-left: 10px;

          .action-icon{
            left: -1px;
          }
        }
      }
    }

    .scroll-buttons {
      display: flex;
      flex-wrap: nowrap;
    }

    .step-indicators {
      position: relative;
      margin-top: 24px;
      flex-grow: 1;
      display: flex;

      .overview-step {
        display: block;
        height: 20px;
        width: 20px;
        background: rgba(255, 255, 255, 0.3);
        margin-right: 10px;
        position: relative;
        top: -8px;
        border-radius: 10px;

        &:hover {
          background: white;
        }

        &.active {
          background: #007fff;
        }
      }

      .journey-progress {
        flex-grow: 1;
      }
    }

    .journey-content-wrapper {
      overflow: hidden;
    }

    .journey-header {
      background: #222222;
      box-shadow: 0 0 10px rgba(34, 34, 34, 0.75);
    }

    @media (max-width: 799px) {
      .scroll-buttons {
        position: fixed;
        right: 40px;
        bottom: 40px;
      }
    }

    @media (max-width: 639px) {
      padding-top: 130px;

      .journey-header {
        height: 130px;
        padding: 10px;
      }

      .step-indicators {
        position: absolute;
        padding: 0 10px;
        left: 0;
        top: 60px;
        max-width: 100%;
        width: 100%;
      }

      .nav-icons {
        width: 100%;

        a.button.all-journeys {
          margin: 0;
        }

        .spacer {
          flex-grow: 1;
          width: 100%;
        }
      }

      .journey-overview {
        flex-basis: calc(100vw - 20px);
      }
    }
  }
</style>

<script>
  import axios from "axios";
  import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
  import LayoutStandard from "@/layouts/standard";
  import JourneyOverview from "@/journeys/JourneyOverview";
  import JourneyProgress from "@/journeys/JourneyProgress";
  import StepOutline from "@/journeys/StepOutline";
  import LeftArrow from "@/common/icons/LeftArrow";
  import RightArrow from "@/common/icons/RightArrow";
  import EmptyGrid from "@/common/icons/EmptyGrid";
  import X from "@/common/icons/X";
  import { FTScroller } from "ftscroller";
  import $ from "jquery";
  import { debounce } from 'lodash';
  import Tooltip from "@/common/components/Tooltip";

  const OVERVIEW_WIDTH = 510;
  const STEP_WIDTH = 405;

  export default {
    name: "journey",
    components: { LayoutStandard, JourneyOverview, JourneyProgress, StepOutline, LeftArrow, RightArrow, EmptyGrid, X, Tooltip },
    computed: {
      loaded() {
        return this.steps && this.currentUser && this.currentEdition && (this.journey.id == this.selectedJourney);
      },
      contentWidth() {
        return this.overviewWidth + this.stepWidth * this.steps.length + this.windowWidth - this.stepWidth;
      },
      overviewWidth() {
        return this.windowWidth >= 640 ? OVERVIEW_WIDTH : this.windowWidth;
      },
      stepWidth() {
        return this.windowWidth >= 640 ? STEP_WIDTH : this.windowWidth;
      },
      ...mapState({
        journey: state => state.journeys.selectedJourneyDetails,
        selectedJourney: state => state.journeys.selectedJourney,
        showJourney: state => state.journeys.showJourney,
        journeys: state => state.journeys.journeys,
        steps: state => state.journeys.selectedJourneyDetails?.steps,
        title: state => state.journeys.selectedJourneyDetails?.title,
        media: state => state.journeys.selectedJourneyDetails?.media,
        id: state => state.journeys.selectedJourneyDetails?.id,
        description: state => state.journeys.selectedJourneyDetails?.description,
        duration: state => state.journeys.selectedJourneyDetails?.duration,
        assigned: state => state.journeys.selectedJourneyDetails?.assigned,
      }),
      ...mapGetters(["currentUser", "currentEdition", "newJourneysCount", "scrollHelpVisible"])
    },
    data () {
      return {
        scrollIndex: null,
        scrollLeft: 0,
        visibleSteps: [],
        canScrollLeft: false,
        canScrollRight: true,
        windowWidth: document.body.offsetWidth,
        showScrollHelp: false
      };
    },
    watch: {
      selectedJourney(selected) {
        if (!this.loaded) {
          this.loadJourney();
        }
      },
      loaded() {
        if (this.loaded) {
          this.$store.commit('setJourneyLoaded', true);
        }
      },
      scrollHelpVisible(visible) {
        if (!visible) {
          this.showScrollHelp = false;
        }
      }
    },
    mounted() {
      window.addEventListener("resize", debounce(() => {
        this.windowWidth = document.body.offsetWidth;
        if(this.scroller && this.scroller.updateDimensions) {
          this.scroller.updateDimensions(this.contentWidth);
        }_
        this.updateVisibleSteps();
      }, 500));
      if (!this.loaded) {
        this.loadJourney();
      }
    },
    activated() {
      // Check for updates
      this.loadJourney(false);
    },
    methods: {
      setJourneyQueryString() {
        this.$router.push({query: { journey: this.selectedJourney } });
      },
      loadJourney(newJourney=true) {
        if (!this.selectedJourney) {
          return;
        }
        axios.get(`/api/journeys/journey/${this.selectedJourney}`)
        .then((response) => {
          this.$store.commit("setSelectedJourneyDetails", response.data);
          this.triggerScrollHelp();
          if (newJourney) {
            this.visibleSteps = [];
            this.scrollIndex = 0;
            this.$nextTick(this.initHorizontalScrolling);
          } else {
            this.scrollTo(this.scrollIndex);
          }
        })
        .catch((error)=>{
          if (error.response && error.response.status === 404) {
            // If trying to load a non-existent journey, just show journey explorer
            this.$store.commit("setShowJourney", false);
            this.$store.commit("setSelectedJourney", null);
            this.$store.commit("setSelectedJourneyDetails", null);
            this.$store.commit("setShowJourneys", true);
          } else {
            console.log(error);
          }
        });
      },
      triggerScrollHelp() {
        setTimeout(() => {
          // Show after a delay and only on desktop
          this.showScrollHelp = !window.Modernizr.touchevents && this.scrollHelpVisible;
        }, 1000);
      },
      updateEnrollment(started){
        if (started) { this.scrollTo(0); }
      },
      scroll(direction) {
        if (this.steps && this.steps.length) {
          if (direction == "left") {
            if (this.scrollIndex === 0) {
              this.scrollIndex = null;
            } else if(this.scrollIndex !== null) {
              this.scrollIndex--;
            }
          } else if (direction =="right") {
            if (this.scrollIndex === null) {
              this.scrollIndex = 0;
            } else if (this.scrollIndex < this.steps.length - 1) {
              this.scrollIndex++;
            }
          }

          if (this.scrollIndex === null ) {
            this.revealOverview();
          } else {
            this.scrollTo(this.scrollIndex);
          }

          this.updateVisibleSteps();
        }
      },
      scrollTo(index) {
        this.scroller.scrollTo(this.overviewWidth + index * this.stepWidth, 0, 400);

        // scroll to top
        window.scrollTo(0, 0);

        this.dismissScrollHelp();
      },
      close() {
        //Clear query param
        this.$router.push({ query: {} });
        this.$store.commit("setShowJourney", false);
      },
      openProfileMenu() {
        this.$store.commit("setMenuOpen", "profile");
      },
      visitJourneys() {
        this.$store.commit("setShowJourneys", true);
        if (this.newJourneysCount > 0) {
          this.$store.commit("clearJourneysCount");
        }
      },
      initHorizontalScrolling() {
        let vm = this;
        let containerElement = this.$refs.scrollContainer;

        this.windowWidth = document.body.offsetWidth;

        let handleScroll = (event) => {
          //get scroll position from ftscroller or native
          let scrollLeft = event.scrollLeft !== undefined ? event.scrollLeft : event.target.scrollLeft;

          // update the scroll index
          if (scrollLeft < this.overviewWidth / 2) {
            this.scrollIndex = null;
          }
          else {
            let stepScrollLeft = scrollLeft - this.overviewWidth;
            this.scrollIndex = Math.floor(stepScrollLeft  / this.stepWidth + 0.5);
          }

          this.updateVisibleSteps();
        };

        this.scroller = new FTScroller(containerElement, {
          contentWidth: this.contentWidth,
          scrollingY: false,
          scrollbars: false,
          alwaysScroll: false,
          updateOnWindowResize: true,
          bouncing: false,
          invertScrollWheel: false,
          scrollBoundary: 10,
          scrollResponseBoundary: 10
        });
        this.scroller.addEventListener('scroll', handleScroll);

        this.updateVisibleSteps();
      },
      revealOverview() {
        if (this.scroller) {
          this.scroller.scrollTo(0, 0, 400);
        }
      },
      updateVisibleSteps() {
        if (!this.steps || !this.scroller) {
          return;
        }
        this.canScrollLeft = this.scroller.scrollLeft > 0;

        let scrollOffset = this.scroller.scrollLeft;
        let visible = [];
        for(let i = 0; i < this.steps.length; i ++) {
          let leftInside = scrollOffset <= this.overviewWidth + this.stepWidth * i + 5;
          let rightInside = this.overviewWidth + this.stepWidth * (i + 1) - scrollOffset <= this.windowWidth + 5;
          if (leftInside && rightInside && this.canScrollLeft) {
            visible.push(i);
            break;
          }
        }
        this.visibleSteps = visible;

        this.canScrollRight = !visible.includes(this.steps.length - 1);
      },
      ...mapActions(["promptStartJourney"]),
      ...mapMutations(["dismissScrollHelp"])
    }
  }

</script>
